import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppConfigService } from '../services/config.service';

import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // 'Access-Control-Allow-Credentials': 'true',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private url = this.conf.appConfig.apiBaseUrl;

  getEncounters() {
    const url = `${this.url}/api/encounter/getall?pagesize=100`;

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getStats(id) {
    const url = `${this.url}/api/encounter/sample/stats?id=${id}`;

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getAcountStat() {
    const url = `${this.url}/api/payments/summary/bill`;

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  searchEncounters(
    startdate,
    enddate,
    dept_code,
    sub_dept_code,
    investigation,
    name,
    gender,
    phone,
    is_verified,
    is_finalized,
    is_collected,
    is_acknowledged,
    is_final,
    pagesize =100,
    pageno=1
  ) {
    const url = `${this.url}/api/encounter/getall?startdate=${startdate}&enddate=${enddate}&dept_code=${dept_code}&sub_dept_code=${sub_dept_code}&investigation=${investigation}&name=${name}&gender=${gender}&phone=${phone}&is_verified=${is_verified}&is_finalized=${is_finalized}&is_collected=${is_collected}&is_final=${is_final}&is_acknowledged=${is_acknowledged}&pagesize=${pagesize}&pageno=${pageno}`;
    console.log(url);

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  searchEncounterServices(
    startdate,
    enddate,
    dept_code,
    sub_dept_code,
    investigation,
    name,
    gender,
    phone,
    is_verified,
    is_finalized,
    is_collected,
    is_acknowledged,
    is_printed,
    is_dispatched,
    is_online,
    is_authorized,
    is_final,
    pagesize =100,
    pageno=1
  ) {
    const url = `${this.url}/api/encounter/services/getall?startdate=${startdate}&enddate=${enddate}&dept_code=${dept_code}&sub_dept_code=${sub_dept_code}&investigation=${investigation}&name=${name}&gender=${gender}&phone=${phone}&is_verified=${is_verified}&is_finalized=${is_finalized}&is_collected=${is_collected}&is_acknowledged=${is_acknowledged}&is_printed=${is_printed}&is_dispatched=${is_dispatched}&is_online=${is_online}&is_authorized=${is_authorized}&is_final=${is_final}&pagesize=${pagesize}&pageno=${pageno}`;
    console.log(url);

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getBillDetail(id) {
    const url = `${this.url}/api/encounter/getdetails?id=${id}`;

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatTypes() {
    const url = `${this.url}/api/encounter/getbilltypes`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));
    
    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postBill(
    is_final,
    id,
    patient_type,
    registration_no,
    patientName,
    branchCode,
    referred_doctor,
    ref_hosp_code,
    concession_code,
    narration,
    barcodeno,
    cardpercent,
    billDate,
    totalAmount,
    discount,
    netAmount,
    amountPaid,
    amountOutstanding,
    discount_narration,
    discount_auth_doc_id,
    Recd_Payt,
    clinical_history,
    encounterServices: [
      {
        service_code;
        service_name;
        service_amount;
        no_of_test;
        dept_code;
        sub_dept_code;
      }
    ],
    encounterBillItems: [
      {
        is_opd;
        service_code;
        service_name;
        discounted_amount;
        discount;
        net_amount;
        no_of_test;
        dept_code;
        sub_dept_code;
      }
    ]
  ) {
    const data = {
      is_final,
      id,
      patient_type,
      registration_no,
      patientName,
      branchCode,
      referred_doctor,
      ref_hosp_code,
      concession_code,
      narration,
      barcodeno,
      cardpercent,
      billDate,
      totalAmount,
      discount,
      netAmount,
      amountPaid,
      amountOutstanding,
      discount_narration,
      discount_auth_doc_id,
      Recd_Payt,
      clinical_history,
      encounterServices,
      encounterBillItems,
    };
    console.log(data);
    const url = `${this.url}/api/encounter/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postPayment(
    receipt_id,
    receipt_no,
    bill_id,
    bill_no,
    registration_no,
    patient_first_name,
    patient_last_name,
    receipt_date,
    bill_amount,
    amount_paid,
    author_id,
    author_name,
    payment_ref,
    payment_type
  ) {
    const data = {
      receipt_id,
      receipt_no,
      bill_id,
      bill_no,
      registration_no,
      patient_first_name,
      patient_last_name,
      receipt_date,
      bill_amount,
      amount_paid,
      author_id,
      author_name,
      payment_ref,
      payment_type,
    };
    console.log(data);
    const url = `${this.url}/api/payments/makepayment`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  updateBill(bill_id, status) {
    const data = {
      bill_id,
      status,
    };
    console.log(data);
    const url = `${this.url}/api/encounter/authorize`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  updatePayment(id, Recd_Payt) {
    const data = {
      id,
      Recd_Payt,
    };
    console.log(data);
    const url = `${this.url}/api/encounter/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getPatients(id) {
    const url = `${this.url}/api/patient/getall?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getRefDrByCode(code) {
    const url = `${this.url}/api/refdoctor/getall?id=${code}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  constructor(private client: HttpClient, private conf: AppConfigService) {}
}
